module.exports = __webpack_public_path__ + "static/media/broadcast.e81c985b.svg";